import React from "react";

interface SallaIconProps {
  isActive?: boolean;
}

export const SallaIcon: React.FC<SallaIconProps> = ({ isActive = false }) => {
  const color = isActive ? "var(--active-color)" : "#83829D";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.7 15.3C4.3 15.7 4.6 16.5 5.1 16.5H17M17 13V19C17 19.6 16.6 20 16 20H8C7.4 20 7 19.6 7 19V13M17 13H7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="9"
        cy="20"
        r="1"
        fill={color}
      />
      <circle
        cx="20"
        cy="20"
        r="1"
        fill={color}
      />
    </svg>
  );
};

